/**
 * Returns a callback to handle touches on nav items that contain sub menus.
 * These 'parent' items should not execute their href links immediately.
 * They need to be tapped twice in a row to be executed.
 * @param {Element} component
 * @return {Function}
 */
const handleTouchFallback = (component) => () => {
    // look up all links in nav items that are parents + all items that are not top-level
    const $parentLinks = $(component).find('.main-nav__item--parent, .main-nav__item:not(.main-nav__item--level-0)').children('a[href]');
    $parentLinks.on('click', (e) => {
        if (!$(e.target).data('isTapped')) {
            // prevent link execution if element is not tapped
            e.preventDefault();
        }
        // remove tapped flag from all elements
        $parentLinks.data('isTapped', false);
        // set tapped flag for current element
        $(e.target).data('isTapped', true);
    });
};

export default handleTouchFallback;



// WEBPACK FOOTER //
// ./src/scripts/components/main-nav/handleTouchFallback.js